import Request from ".";
import { Routes } from "../constant/api_url";

const createInvoiceApi = async (data) => {
  try {
    const result = await Request.post(Routes.CREATEINVOICE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateInvoiceApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEINVOICE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCustomerListForInvoiceApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETCUSTOMERLISTFORINVOICE, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getInvoiceListApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETINVOICELIST, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCityPackageAmountApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYPACKAGEAMOUNT, data);

    return result.data;
  } catch (error) {
    throw error;
  }
};

const validateInvoiceLinkApi = async (data) => {
  try {
    const result = await Request.post(Routes.VALIDATEINVOICELINK, data);

    return result.data;
  } catch (error) {
    throw error;
  }
};

const sendInvoiceOtpToMobileApi = async (data) => {
  try {
    const result = await Request.post(Routes.SENDINVOICEOTPTOMOBILE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });

    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMemberInvoiceDetailsApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERINVOICEDETAILS, data);

    return result.data;
  } catch (error) {
    throw error;
  }
};

const generateMemberInvoiceApi = async (data) => {
  try {
    const result = await Request.post(Routes.GENERATEMEMBERINVOICE, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const generateMemberInvoiceFromAdminApi = async (data) => {
  try {
    const result = await Request.post(Routes.GENERATEMEMBERINVOICEFROMADMIN, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const fetchGstDetailsbynumberApi = async (data) => {
  try {
    const result = await Request.post(Routes.FETCHGSTDETAILSBYNUMBER, data);

    return result.data;
  } catch (error) {
    throw error;
  }
};

const sendInvoiceReminderToMemberApi = async (data) => {
  try {
    const result = await Request.post(Routes.SENDINVOICEREMINDERTOMEMBER, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getInvoiceListZipApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETINVOICELISTZIP, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateInvoiceDetailsApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEINVOICEDETAILS, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getStateListApi = async () => {
  try {
    const result = await Request.post(Routes.GETSTATELIST, {});
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCityListByStateApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYLISTBYSTATE, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateInvoiceStatusApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEINVOICESTATUS, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

export {
  createInvoiceApi,
  updateInvoiceApi,
  getInvoiceListApi,
  getCustomerListForInvoiceApi,
  getCityPackageAmountApi,
  validateInvoiceLinkApi,
  sendInvoiceOtpToMobileApi,
  getMemberInvoiceDetailsApi,
  generateMemberInvoiceApi,
  generateMemberInvoiceFromAdminApi,
  fetchGstDetailsbynumberApi,
  sendInvoiceReminderToMemberApi,
  getInvoiceListZipApi,
  updateInvoiceDetailsApi,
  getStateListApi,
  getCityListByStateApi,
  updateInvoiceStatusApi
};
